<div class="formulario-contenido-menu">
  <div class="formulario-header">
    <div class="header-main-flex">
      <div class="header-titulos">
        <h2>Registrar Visita</h2>
        <p class="subtitulo subtitulo-registrar">
          Registre los resultados de la visita a <strong>{{ row.nombreProductor }}</strong>.
        </p>
        <ion-text color="primary" class="registro-borrador-hint" *ngIf="pendienteIdReutilizable">
          <p>Continuando con el borrador guardado en este dispositivo. Puede editarlo y volver a guardar.</p>
        </ion-text>
      </div>
    </div>
    <ion-button fill="clear" size="small" class="btn-cerrar" (click)="cerrar()" aria-label="Cerrar">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="formulario-content ruta-accion-panel-scroll" #contenidoScroll>
    <form [formGroup]="formularioRegistro" class="form-registro">
      <section class="registro-seccion">
        <h3 class="registro-seccion-titulo">FECHA Y HORA DE REALIZACIÓN</h3>
        <div class="registro-fecha-hora">
          <div class="registro-campo form-item">
            <ion-label position="stacked">FECHA DE VISITA <span class="required">*</span></ion-label>
            <ion-datetime-button [datetime]="'reg-off-fecha-' + idSuffix"></ion-datetime-button>
            <ion-popover [keepContentsMounted]="true">
              <ng-template>
                <ion-datetime
                  [id]="'reg-off-fecha-' + idSuffix"
                  [value]="fechaVisitaRegistroISO || undefined"
                  [min]="getFechaMinimaRegistroISO()"
                  (ionChange)="onFechaRegistroChange($event)"
                  locale="es-CL"
                  presentation="date"
                  [formatOptions]="{ date: { day: '2-digit', month: '2-digit', year: 'numeric' } }">
                </ion-datetime>
              </ng-template>
            </ion-popover>
          </div>
          <div class="registro-campo form-item">
            <ion-label position="stacked">HORA INICIO <span class="required">*</span></ion-label>
            <ion-datetime-button [datetime]="'reg-off-ini-' + idSuffix"></ion-datetime-button>
            <ion-popover [keepContentsMounted]="true">
              <ng-template>
                <ion-datetime
                  [id]="'reg-off-ini-' + idSuffix"
                  [value]="horaInicioRegistro || undefined"
                  (ionChange)="onHoraInicioRegistroChange($event)"
                  locale="en-US"
                  presentation="time"
                  [formatOptions]="{ time: { hour: '2-digit', minute: '2-digit', hour12: true } }">
                </ion-datetime>
              </ng-template>
            </ion-popover>
          </div>
          <div class="registro-campo form-item">
            <ion-label position="stacked">HORA TÉRMINO</ion-label>
            <ion-datetime-button [datetime]="'reg-off-fin-' + idSuffix"></ion-datetime-button>
            <ion-popover [keepContentsMounted]="true">
              <ng-template>
                <ion-datetime
                  [id]="'reg-off-fin-' + idSuffix"
                  [value]="getHoraTerminoRegistroValueISO()"
                  [min]="getHoraTerminoMinimaRegistroISO()"
                  (ionChange)="onHoraTerminoRegistroChange($event)"
                  locale="en-US"
                  presentation="time"
                  [formatOptions]="{ time: { hour: '2-digit', minute: '2-digit', hour12: true } }">
                </ion-datetime>
              </ng-template>
            </ion-popover>
          </div>
        </div>
        <ion-text color="warning" class="registro-aviso-fecha" *ngIf="registroFechaHoraBloqueadoPorAgenda()">
          <p>
            La fecha y hora de <strong>realización</strong> deben ser iguales o posteriores a la visita
            <strong>agendada</strong>
            <span *ngIf="textoReferenciaAgendaFormateado()"> ({{ textoReferenciaAgendaFormateado() }})</span>.
            Ajuste la hora de inicio (o la fecha) para poder completar el registro.
          </p>
        </ion-text>
        <ion-text color="medium" class="registro-aviso-fecha" *ngIf="faltaConfirmarHoraInicioModelo()">
          <p>Abra <strong>Hora inicio</strong> y confirme el valor en el selector para habilitar «Completar Visita».</p>
        </ion-text>
      </section>

      <section class="registro-seccion">
        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">Desarrollo Asesoría <span class="required">*</span></ion-label>
          <ion-textarea
            formControlName="desarrollo_asesoria"
            placeholder="Describa las actividades realizadas..."
            rows="4">
          </ion-textarea>
        </ion-item>
      </section>

      <section class="registro-seccion">
        <ion-radio-group formControlName="tipo_reporte" class="tipo-reporte-group" allowEmptySelection="true">
          <ion-label class="tipo-reporte-label"> TIPO DE REPORTE <span class="required">*</span> </ion-label>
          <div class="tipo-reporte-options" role="group" aria-label="Tipo de reporte">
            <ion-radio class="tipo-reporte-radio" value="digital" labelPlacement="end" justify="start">
              Digital
            </ion-radio>
            <ion-radio class="tipo-reporte-radio" value="papel" labelPlacement="end" justify="start">
              Papel
            </ion-radio>
          </div>
        </ion-radio-group>
      </section>

      <section class="registro-seccion" *ngIf="getTipoReporteRegistro()">
        <h3 class="registro-seccion-titulo">DETALLES DEL REGISTRO</h3>
        <div class="registro-objetivo-folio">
          <div class="registro-campo form-item registro-campo-fila-completa">
            <ion-label position="stacked">TEMAS <span class="required">*</span></ion-label>
            <app-selector-objetivos-visita-registro
              formControlName="id_objetivo_visita"
              [objetivosVisita]="objetivosVisita">
            </app-selector-objetivos-visita-registro>
          </div>
          <div class="registro-campo form-item registro-campo-fila-completa">
            <ion-label position="stacked">MODALIDAD DE CONTACTO <span class="required">*</span></ion-label>
            <ion-select
              formControlName="id_modalidad_contacto"
              placeholder="Seleccione modalidad"
              interface="popover"
              [compareWith]="compareIdModalidadContacto"
              [disabled]="!esModalidadContactoRegistroEditable()"
              [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
              <ion-select-option *ngFor="let mod of modalidadesContacto" [value]="mod.id_modalidad_contacto">
                {{ mod.descripcion }}
              </ion-select-option>
            </ion-select>
          </div>
          <div class="registro-campo form-item registro-campo-generar-folio">
            <div class="registro-generar-folio-wrapper">
              <ion-item class="form-item form-item-checkbox" lines="none">
                <ion-checkbox formControlName="generar_folio" labelPlacement="end">
                  Generar Folio
                </ion-checkbox>
              </ion-item>
              <ion-button [id]="idGenerarFolioInfo" fill="clear" size="small" class="boton-informacion"
                aria-label="Información sobre generar folio">
                <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
              </ion-button>
              <ion-popover [trigger]="idGenerarFolioInfo" [triggerAction]="'click'" reference="trigger" [side]="'top'"
                [alignment]="'center'">
                <ng-template>
                  <div class="popover-informacion">
                    <p>Al marcar esta opción, el sistema asignará automáticamente un número de folio al registrar la visita. No debe ingresar el folio del manifold manualmente.</p>
                  </div>
                </ng-template>
              </ion-popover>
            </div>
          </div>
          <div class="registro-campo form-item">
            <ion-label position="stacked">FOLIO
              <span class="required" *ngIf="esFolioRegistroManualRequerido()">*</span>
            </ion-label>
            <ion-input formControlName="folio" placeholder="Nro. de folio del manifold" maxlength="15"
              [readonly]="!esFolioRegistroEditable()" (ionInput)="onFolioInput($event)"></ion-input>
          </div>
        </div>
        <div class="registro-campo bloque form-item">
          <ion-label position="stacked">
            RECOMENDACIONES
            <span class="required" *ngIf="getTipoReporteRegistro() === 'digital'">*</span>
          </ion-label>
          <ion-textarea
            formControlName="recomendaciones"
            placeholder="Indique las recomendaciones técnicas entregadas..."
            rows="3"
            class="registro-textarea" maxlength="500">
          </ion-textarea>
          <div class="contador-caracteres">
            {{ formularioRegistro.get('recomendaciones')?.value?.length || 0 }} de 500
          </div>
        </div>
        <div class="registro-campo bloque form-item">
          <ion-label position="stacked">
            COMPROMISOS ADQUIRIDOS
            <span class="required" *ngIf="getTipoReporteRegistro() === 'digital'">*</span>
          </ion-label>
          <ion-textarea
            formControlName="compromisos"
            placeholder="Liste los compromisos del productor y/o asesor..."
            rows="3"
            class="registro-textarea" maxlength="500">
          </ion-textarea>
          <div class="contador-caracteres">
            {{ formularioRegistro.get('compromisos')?.value?.length || 0 }} de 500
          </div>
        </div>
      </section>

      <section class="registro-seccion" *ngIf="getTipoReporteRegistro()">
        <h3 class="registro-seccion-titulo">
          ARCHIVOS ANEXOS
          <span class="required" *ngIf="getTipoReporteRegistro() === 'papel'">*</span>
        </h3>
        <p class="registro-hint">Cada archivo debe tener una categoría. Use el botón + para agregar más.</p>
        <div class="registro-adjuntos">
          <div class="registro-fila-adjunto" *ngFor="let item of itemsRegistroArchivos; let i = index">
          <div class="registro-fila-archivo">
            <input
              type="file"
              [id]="'file-reg-off-' + idSuffix + '-' + i"
              class="file-input-registro"
              [attr.accept]="fileUploadAccept"
              (change)="onArchivoRegistroFilaChange(i, $event)" />
            <label [for]="'file-reg-off-' + idSuffix + '-' + i" class="file-label-registro">
              {{ nombreArchivoRegistroFila(i) }}
            </label>
          </div>
          <div class="registro-fila-nativo" *ngIf="esPlataformaNativa">
            <ion-button
              fill="outline"
              size="small"
              type="button"
              (click)="adjuntarDesdeCamaraNativo(i, 'camera')"
              [disabled]="guardando">
              <ion-icon slot="start" name="camera-outline"></ion-icon>
              Cámara
            </ion-button>
            <ion-button
              fill="outline"
              size="small"
              type="button"
              (click)="adjuntarDesdeCamaraNativo(i, 'gallery')"
              [disabled]="guardando">
              <ion-icon slot="start" name="images-outline"></ion-icon>
              Galería
            </ion-button>
          </div>
            <ion-select
              [value]="item.id_categoria || ''"
              placeholder="Categoría"
              interface="popover"
              [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }"
              (ionChange)="onCategoriaRegistroFilaChange(i, $any($event).detail?.value)"
              class="registro-select-categoria"
              [class.ion-invalid]="item.file && !item.id_categoria"
              [class.ion-touched]="item.file && !item.id_categoria">
              <ion-select-option value="">Seleccione Categoría</ion-select-option>
              <ion-select-option *ngFor="let cat of categoriasAnexo" [value]="cat.id">
                {{ cat.descripcion }}
              </ion-select-option>
            </ion-select>
            <div class="registro-error-adjunto" *ngIf="item.file && !item.id_categoria" role="alert" aria-live="polite">
              Seleccione Categoría <span class="required">*</span>
            </div>
            <ion-button
              fill="clear"
              size="small"
              color="danger"
              class="btn-quitar-adjunto"
              (click)="eliminarFilaArchivoRegistro(i)"
              title="Quitar archivo"
              aria-label="Quitar archivo">
              <ion-icon slot="icon-only" name="trash-outline" aria-hidden="true"></ion-icon>
            </ion-button>
          </div>
          <ion-button fill="outline" size="small" class="btn-agregar-adjunto" (click)="agregarFilaArchivoRegistro()">
            <ion-icon slot="start" name="add-outline"></ion-icon>
            AGREGAR ARCHIVO
          </ion-button>
        </div>
      </section>
    </form>
  </div>

  <div class="formulario-footer tres-botones">
    <ion-button fill="outline" (click)="cerrar()" [disabled]="guardando">Cancelar</ion-button>
    <ion-button (click)="completar()" [disabled]="guardando || !esFormularioValido()">
      <ion-icon slot="start" name="save-outline"></ion-icon>
      {{ guardando ? 'Guardando…' : 'Completar Visita' }}
    </ion-button>
  </div>
</div>
